<template>
  <base-container ref="container" v-loading="loading">
    <el-container style="height: 100%; padding: 0">
      <el-header height="240px" style="padding: 0">
        <artisan-group>
          <el-row
            slot="header"
            type="flex"
            align="middle"
            justify="space-between"
            class="align-center back-white padding-v5"
          >
            <span>基本信息</span>
            <el-radio-group size="mini" v-model="designer">
              <el-radio-button label="ColumnForm">列表设计</el-radio-button>
              <el-radio-button label="TableDesigner">列表预览</el-radio-button>
              <el-radio-button label="FormDesigner">表单预览</el-radio-button>
            </el-radio-group>
            <div>
              <el-button
                type="success"
                size="mini"
                icon="el-icon-check"
                @click="save"
              >
                保存
              </el-button>
              <el-button
                type="primary"
                size="mini"
                plain
                icon="el-icon-check"
                @click="autoCreate"
              >
                获取列数据
              </el-button>
            </div>
          </el-row>
          <ArtisanForm
            style="padding: 0; margin: 0"
            v-model="meta"
            metaKey="SysMetaGrid"
            :metaLoaded="metaGridLoaded"
            ref="metaForm"
          ></ArtisanForm>
        </artisan-group>
      </el-header>
      <el-main
        style="
          padding: 0;
          height: calc(100% - 240px);
          border-top: 1px #1890ff solid;
        "
      >
        <el-container style="height: 100%; padding: 0">
          <el-main style="padding: 0; height: 100%; overflow: hidden">
            <artisan-group :title="title" style="height: 100%">
              <transition name="el-zoom-in-center">
                <ArtisanForm
                  v-if="designer == 'ColumnForm'"
                  labelWidth="80px"
                  v-model="column"
                  metaKey="SysMetaColumn"
                ></ArtisanForm>
                <component v-else :is="designer" v-model="meta"></component>
              </transition>
            </artisan-group>
          </el-main>
          <el-aside width="25%" style="height: 100%; overflow: hidden">
            <artisan-group title="字段列表" style="height: 100%">
              <template #header>
                <el-row type="flex" align="middle" justify="space-between">
                  <span>字段列表</span>
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-plus"
                    @click="addColumn"
                    >字段</el-button
                  >
                </el-row>
              </template>
              <draggable
                :animation="340"
                :list="meta.columns"
                handle=".movable"
              >
                <el-row
                  type="flex"
                  justify="space-between"
                  align="middle"
                  :class="
                    column.code == item.code
                      ? 'color-white back-primary'
                      : 'color-primary back-primary-light'
                  "
                  class="margin-v5 padding5 movable"
                  v-for="(item, index) in meta.columns"
                  :key="item.code"
                  @click.native="editColumn(item)"
                >
                  <span> {{ index + 1 }}.{{ item.name }}</span>
                  <span>
                    <i
                      class="el-icon-delete color-danger clickable"
                      @click="delColumn(item, index)"
                    ></i>
                  </span>
                </el-row>
              </draggable>
            </artisan-group>
          </el-aside>
        </el-container>
      </el-main>
    </el-container>
    <artisan-dialog
      ref="dialog"
      title="编辑列"
      height="75%"
      width="75"
      :visible.sync="isEditDialog"
    >
    </artisan-dialog>
  </base-container>
</template>

<script>
import FormDesigner from "./FormDesigner.vue";
import TableDesigner from "./TableDesigner.vue";
import draggable from "vuedraggable";
import { get, save, getColumns } from "@/api/sys/meta";
import { mapMutations } from "vuex";
export default {
  props: ["query"],
  components: {
    draggable,
    FormDesigner,
    TableDesigner,
  },
  data() {
    return {
      loading: false,
      designer: "ColumnForm",
      meta: {
        columns: [],
      },
      column: {},
      isEditDialog: false,
    };
  },
  computed: {
    isEdit() {
      return this.query && this.query.metaId;
    },
    title() {
      let title = "字段列属性";
      switch (this.designer) {
        case "TableDesigner":
          title = "列表预览";
          break;
        case "FormDesigner":
          title = "表单预览";
          break;
      }
      return title;
    },
  },
  created() {
    if (this.isEdit) {
      this.loading = true;
      get(this.query.metaId).then((res) => {
        this.meta = res.data.data;
        this.loading = false;
      });
    }
  },
  methods: {
    ...mapMutations(["refreshTab"]),
    editColumn(column) {
      this.column = column;
    },
    addColumn() {
      let column = {
        isValid: true,
        code: "code_" + this.meta.columns.length,
        name: "字段名称" + this.meta.columns.length,
        dataType: "string",
        inputType: "input",
        width: "200",
        overTooltip: false,
        isAdd: false,
        isEdit: false,
        isView: false,
        required: false,
        fixed: false,
        isSearch: false,
        sortable: false,
        validMin: 0,
        validMax: 0,
        metaId: this.meta.id,
      };
      this.meta.columns.push(column);
      this.column = column;
    },
    delColumn(column, index) {
      this.meta.columns.splice(index, 1);
    },
    metaGridLoaded(data) {
      if (this.isEdit) {
        data.columns = data.columns.filter((c) => c.isEdit);
      } else {
        data.columns = data.columns.filter((c) => c.isAdd);
      }
    },
    save() {
      this.$refs.metaForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.meta.columns.forEach((c, i) => {
            c.sortNo = i + 1;
          });
          save(this.meta)
            .then((res) => {
              let data = res.data.data;
              this.meta.id = data.id;
              this.meta.columns = data.columns;
              this.loading = false;
              this.refreshTab("元数据管理");
              this.$emit("saved", this.meta);
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$message({
            type: "error",
            message: "请完成必填项！",
          });
        }
      });
    },
    autoCreate() {
      if (this.meta.id) {
        getColumns(this.meta.id).then((res) => {
          const data = res.data.data;
          data.forEach((c) => {
            this.meta.columns.push(c);
          });
        });
      } else {
        this.$message({
          type: "error",
          message: "请先保存元数据！",
        });
      }
    },
  },
};
</script>

<style></style>
